/**
 * 响应式下，弹出图层选项
 * 
 * @Author: Focci
 * @Date: 2024-11-08 15:51:10
 * @Last Modified by: Focci
 * @Last Modified time: 2024-11-08 15:51:10
 */

// import PropTypes from 'prop-types'
import clsx from 'clsx'
import SVGLayer from '@img/layer.svg'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import useResizeObserver from '@hook/useResizeObserver'
import { useMap } from 'react-map-gl'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { ButtonBase, Drawer, Portal } from '@comp/material'
import { useMapState } from '..'
import { OverallLayerScoff } from './overall/OverallLayer'
import ControllerWrapper from './ControllerWrapper'
import OverallController from './overall/controller'
import useMapboxOverall from './overall/useMapboxOverall'
import OverallLegends from './overall/legends'
import TrafficPanel from './overall/panel/TrafficPanel'
import FacilityPanel from './overall/panel/FacilityPanel'

function LayerDrawer({ type, traffic, facility, ...props }) {
  const ts = useTranslations('search')
  const opt = useMapboxOverall({ type })

  return (
    <>
      <Drawer anchor="right" {...props} ModalProps={{ className: 'z-[10000]' }}>
        <div className="w-[65vw]">
          <div className="p-2 border-b">
            <ButtonBase onClick={props.onClose}>
              <ArrowBackIcon />
              <span className="text-f.8">{ts('layerCategory')}</span>
            </ButtonBase>
          </div>
          <OverallController 
            {...opt} 
            traffic={traffic} 
            facility={facility}
          />
        </div>
      </Drawer>
      {/* 保证在不展开Drawer时，地图layer能正常展示 */}
      {/* <OverallController 
        {...opt}
        justDisplayMapboxLayer
        traffic={traffic} 
        facility={facility}
      /> */}
    </>
  )
}

function LayerLegend({ type, facility, traffic }) {
  const ts = useTranslations('search')
  const mps = useMapState()
  const { legends } = useMapboxOverall({ type })
  const { current } = useMap()
  const { height } = useResizeObserver(current?.getContainer?.())
  const hasLegends = legends.length > 0
  
  if(!(hasLegends || facility || traffic)) {
    return null
  }

  return (
    <Portal>
      <div 
        className={clsx([
          'fixed px-2 z-[20] flex flex-col gap-2',
          // 房源详情才有 facility和traffic
          (facility || traffic) ? 'bottom-2 left-0 right-0' : 'left-0 max-w-[70vw] top-[4.5rem]'
        ])}
      >
        {hasLegends && (
          <OverallLayerScoff
            autoCloseTime={10}
            title={ts('legend')}
            bodyHeight={height * 0.35}
          >
            <OverallLegends legends={legends} />
          </OverallLayerScoff>
        )}
        {traffic && mps.traffic && <TrafficPanel {...traffic} />}
        {facility && mps.facilityPanel && <FacilityPanel {...facility} />}
      </div>
    </Portal>
  )
}

export default function LayersController({ type, ...opt }) {
  const [open, setOpen] = useState(true)
  
  return (
    <>
      <ControllerWrapper small onClick={() => setOpen(true)}>
        <SVGLayer />
      </ControllerWrapper>
      <LayerLegend type={type} {...opt} />
      <LayerDrawer 
        type={type}
        {...opt}
        open={open} 
        onClose={() => setOpen(false)} 
      />
    </>
  )
}

// LayersController.propTypes = {
//   className: PropTypes.string,
// }
